import React, { useState } from 'react';
import { SaveButton as RASaveButton, Toolbar, useRefresh, useNotify, useRecordContext, useTranslate } from 'react-admin';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import EmailIcon from '@mui/icons-material/Email';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useWatch, useFormContext } from 'react-hook-form';

import SimpleForm from '../../common/forms/SimpleForm';
import IconButton from '../../common/buttons/IconButton';

import { sendInvoiceEmail } from '../../../services/api';

const toolbarSx = {
	padding: '0 !important',
	minHeight: 'auto !important',
	backgroundColor: 'transparent',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	gap: '15px'
};

const SaveButton = ({ onClick, ...props }) => {
	const record = useRecordContext();
	const { setValue } = useFormContext();
	const subject = useWatch({ name: 'subject' });
	const message = useWatch({ name: 'message' });
	const notify = useNotify();

	const handleClick = async () => {
		let data = {};
		if (subject) {
			data.subject = subject;
		}
		if (message) {
			data.message = message;
		}

		const response = await sendInvoiceEmail(record.id, JSON.stringify(data));
		if (response.success || response.id) {
			notify('Invoice sent by email');
		}
		else if (!response.success && response.message) {
			notify(response.message, 'warning');
		}
		else {
			notify('Sending the invoice failed', 'warning');
		}

		setValue('subject', '');
		setValue('message', '');
		onClick();
	};

	return <RASaveButton {...props} onClick={handleClick} label="Send" icon={<EmailIcon />} alwaysEnable />;
};

const CustomToolbar = ({ onSave, onClose }) => {
	const translate = useTranslate();

	return (
		<Toolbar sx={toolbarSx}>
			<IconButton icon={<ErrorOutlineIcon />} onClick={onClose}>{translate('ra.action.cancel')}</IconButton>
			<SaveButton onClick={onSave} />
		</Toolbar>
	);
};

const SendEmailButton = () => {
	const record = useRecordContext();
	const refresh = useRefresh();
	const translate = useTranslate();
	const [showDialog, setShowDialog] = useState(false);

	const handleSave = async () => {
		handleClose();
		refresh();
	};

	const handleOpen = () => {
		setShowDialog(true);
	};

	const handleClose = () => {
		setShowDialog(false);
	};

	if (!record) {
		return null;
	}

	// Show for all unsent invoices (let API handle detailed validation)
	const shouldShow = !record.sent_at;

	if (!shouldShow) {
		return null;
	}

	return (
		<>
			<IconButton icon={<EmailIcon />} onClick={handleOpen}>Send by Email</IconButton>

			{/* Send invoice dialog */}
			<Dialog fullWidth open={showDialog} onClose={handleClose} aria-label="Send invoice by email">
				<DialogTitle>{translate('Send invoice by email')}</DialogTitle>
				<DialogContent>
					{translate('Do you want to send the invoice %{number} by email?', { number: record.number })}
					<SimpleForm toolbar={<CustomToolbar onSave={handleSave} onClose={handleClose} />} record={record}>
						{/* TODO: uncomment for future step */}
						{/* <TextInput source="subject" helperText={false} fullWidth />
						<TextInput source="message" options={{ multiline: true }} rows="4" helperText={false} fullWidth /> */}
					</SimpleForm>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default SendEmailButton;
